// extracted by extract-css-chunks-webpack-plugin
module.exports = {"boundary":"errorBoundary__boundary--14VL-","heading":"errorBoundary__heading--3HNf7","subHeader":"errorBoundary__subHeader--1w2kT"};